function validateFluids(caseConf) {
  const errors = [];
  const caseFluids = caseConf.fluids || [];

  // IV Requirements
  if (caseFluids.length > 0 && !caseConf.iv.enabled) {
    errors.push(ivError(
      'IV must be enabled when fluids are used', 'enabled'
    ));
  }

  // Number of fluids
  if (caseFluids.length > 31) {
    errors.push(fluidsError(
      'There can only be up to 31 fluids enabled', 'fluid-count'
    ));
  }

  for (const caseFluid of caseFluids) {
    // Dosing types
    if (!caseFluid.infusionDosingTypes || caseFluid.infusionDosingTypes.length === 0) {
      errors.push(fluidError(
        'Fluid must have at least one dosing selected', caseFluid.id, 'infusionDosingTypes'
      ));
    }
    // Bag volumes
    if (!caseFluid.infusionBagVolumes || caseFluid.infusionBagVolumes.length === 0) {
      errors.push(fluidError(
        'Fluid must have at least one volume selected', caseFluid.id, 'infusionBagVolumes'
      ));
    }
    // Formularies
    for (let i = 0; i < (caseFluid.formularies || []).length; i++) {
      const formulary = caseFluid.formularies[i];
      if (formulary.dose <= 0) {
        errors.push(fluidError(
          'Formulary dose must be greater than 0', caseFluid.id, `formulary[${i}].dose`
        ));
      }
      if (caseFluid.infusionDosingTypes && !caseFluid.infusionDosingTypes.includes(formulary.dosing)) {
        errors.push(fluidError(
          'Formulary dosing must belong to the fluid\'s selected dosings', caseFluid.id, `formulary[${i}].dosing`
        ));
      }
      if (caseFluid.infusionBagVolumes && !caseFluid.infusionBagVolumes.includes(formulary.volume)) {
        errors.push(fluidError(
          'Formulary volume must belong to the fluid\'s selected volumes', caseFluid.id, `formulary[${i}].volume`
        ));
      }
    }
  }

  return {
    errors,
    warnings: [],
  };
}

function fluidsError(message, id) {
  return {
    message,
    category: 'medications',
    field: 'fluids',
    id,
    metadata: {
      scope: 'control',
    },
  };
}

function fluidError(message, fluidKey, propertyName) {
  return {
    message,
    category: 'medications',
    field: 'fluids',
    id: fluidKey,
    metadata: {
      scope: 'control',
      propertyName,
    },
  };
}

function ivError(message, id) {
  return {
    message,
    category: 'ivs',
    field: 'iv',
    id,
    metadata: {
      scope: 'control',
    },
  };
}

export default validateFluids;
